import React from 'react';
import { Box } from '@mui/material';
import Text from './Text';
import { colors } from '../theme/designTokens';

const ContactInfoRow = ({ label, value, icon, light = false }) => (
  <Box
    sx={{
      display: 'flex',
      gap: 2,
      alignItems: 'flex-start',
      py: 1.5,
      borderBottom: light ? `1px solid ${colors.borderLight}` : '1px solid rgba(255,255,255,0.08)',
      '&:last-child': { borderBottom: 'none' },
    }}
  >
    {icon && (
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: '12px',
          background: light ? 'rgba(59,130,246,0.08)' : 'rgba(238,186,43,0.15)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          fontSize: '1.1rem',
          color: light ? colors.navy : 'inherit',
        }}
      >
        {icon}
      </Box>
    )}
    <Box>
      <Text variant="label" color="goldDark" sx={{ mb: 0.5, display: 'block' }}>
        {label}
      </Text>
      <Text variant="bodySm" color={light ? 'secondary' : 'muted'}>
        {value}
      </Text>
    </Box>
  </Box>
);

export default ContactInfoRow;
